import React from 'react';

const CnSkeleton = window.CNUIM?.CnSkeleton;

export default function Skeleton({ contentLength }: { contentLength: number }) {
  if (!CnSkeleton) {
    return null;
  }
  return (
    <div className="cn-data-table">
      <CnSkeleton className="d" style={{ width: '100%' }}>
        <CnSkeleton.Paragraph lineCount={contentLength} animated />
      </CnSkeleton>
    </div>
  );
}
